import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  SendHighStressNotificationData,
  ActionType,
} from "models/stressCheck/sendHighStressNotification";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { sendHighStressNotification } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./sendHighStressNotiActions";

function* sendHighStressNotificationSaga({
  payload,
}: {
  payload: SendHighStressNotificationData;
}) {
  try {
    const response: IResponse = yield call(sendHighStressNotification, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSendHighStressNotificationWatcher() {
  yield takeLatest(
    ActionType.SEND_HIGH_STRESS_NOTIFICATION as any,
    sendHighStressNotificationSaga
  );
}

export default [fork(onSendHighStressNotificationWatcher)];
